import {Box, styled} from "@mui/material";

export const Column = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
}));